<template>
  <b-container fluid="sm" class="background-grey columns-content short-articles clear"
               style="display: block; ">
    <ul class="fa-ul">
      <li class="tier-benefits">
        RESOURCES
      </li>
      <li class="tier-benefits"><span class="fa-li">
                                <em class="fas fa-check-circle" style="color: #6fb750"></em>
                                    </span>
        <a :href="`${getLinkPair('Communications Kit').link}`"
           target="_blank">Communications
          Kit</a>
      </li>

      <li class="tier-benefits"><span class="fa-li">
                                <em class="fas fa-check-circle" style="color: #6fb750"></em>
                                    </span><a :href="`${getLinkPair('Cultivating a Green Team').link}`"
                                              target="_blank">Cultivating
        a Green Team</a>
      </li>

      <li class="tier-benefits"><span class="fa-li">
                                <em class="fas fa-check-circle" style="color: #6fb750"></em>
                                    </span><a :href="`${getLinkPair('Environmentally Preferable Purchasing Overview').link}`"
                                              target="_blank">Environmentally
        Preferable Purchasing Overview</a>
      </li>

      <li class="tier-benefits"><span class="fa-li">
                                <em class="fas fa-check-circle" style="color: #6fb750"></em>
                            </span><a :href="`${getLinkPair('EPP Policy Template').link}`"
                                      target="_blank"> EPP Policy
        Template</a>
      </li>

      <li class="tier-benefits"><span class="fa-li">
                                <em class="fas fa-check-circle" style="color: #6fb750"></em>
                                    </span><a :href="`${getLinkPair('Shipping Material Recommendations').link}`"
                                              target="_blank">
        Shipping
        Material Recommendations</a>
      </li>

      <li class="tier-benefits"><span class="fa-li">
                                <em class="fas fa-check-circle" style="color: #6fb750"></em>
                                    </span><a
          :href="`${getLinkPair('Installing Water Flow Meters').link}`"
          target="_blank">Installing
        Water Flow Meters</a>
      </li>

      <li class="tier-benefits"><span class="fa-li">
                                <em class="fas fa-check-circle" style="color: #6fb750"></em>
                                    </span><a :href="`${getLinkPair('Solar Monitoring & Maintenance').link}`"
                                              target="_blank">Solar
        Monitoring & Maintenance</a>
      </li>

      <li class="tier-benefits" v-if="isNotCertifier"><span class="fa-li">
                                <em class="fas fa-check-circle" style="color: #6fb750"></em>
                            </span>
        <router-link to="metrics-tabbed">Metric Calculator</router-link>
      </li>

      <li class="tier-benefits"><span class="fa-li">
                                <em class="fas fa-check-circle" style="color: #6fb750"></em>
                                    </span><a :href="`${getLinkPair('PG&E Authorization').link}`" target="_blank">
        PG&E Authorization</a>
      </li>
      <li class="tier-benefits"><span class="fa-li">
                                <em class="fas fa-check-circle" style="color: #6fb750"></em>
                                    </span><a
          :href="`${getLinkPair('Napa Green Access and Confidentiality Agreement').link}`"
          target="_blank">
        Napa Green Access and Confidentiality Agreement</a>
      </li>
    </ul>
  </b-container>
</template>

<script>
import axios from "axios";

export default {
  name: "resource-links",
  data() {
    return {
      links: []
    }
  },
  mounted() {
    this.getLinks();
  },
  methods: {
    downloadDocument: async function () {
      let url = "/static/epp_policy_template.docx";
      axios.get(url, {responseType: 'blob'})
          .then(({data}) => {
            const blob = new Blob([data], {type: 'application/docx'})
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'epp_policy_template.docx'
            link.click()
          }).catch(error => console.error(error))
    },
    getLinks: function () {
      let self = this;
      let linksUrl = "/resources/links";
      this.$http.get(linksUrl)
          .then(links => {
            self.links = links.data;
          })
    },
    getLinkPair: function(linkName){
      let resourceLink = this.links.find(link =>{
        return link.name === linkName;
      });
      return resourceLink ? resourceLink : {name: '', link: ''};
    }
  },
  computed: {
    isNotCertifier: function () {
      return !localStorage.getItem("roles").includes("THIRD_PARTY_CERTIFIER");
    }
  }
}
</script>

<style scoped>

</style>
